export const REGIONS = {
  AUS: { code: "AUS", name: "Australia" },
  GB: { code: "GB", name: "United Kingdom" },
  USA: { code: "USA", name: "United States" },
} as const;

export type TRegionKey = keyof typeof REGIONS;
export type TRegion = (typeof REGIONS)[TRegionKey];

export const REGION_DISPLAY_ORDER = (["AUS", "USA", "GB"] as (keyof typeof REGIONS)[]).map((code) => REGIONS[code]);
